import { styledPolymorphic } from '@qred/components-library';

export const ProgressBar = styledPolymorphic<'progress', {}>()(
  (styled) => styled`
    appearance: none;
    height: 0.25em;
    width: 100%;
    border: none;

    &::-webkit-progress-bar {
      background-color: ${({ theme }) =>
        theme.fn.themeColor('Main/Grey/Alpha/OnLight/10%')};
    }

    &::-webkit-progress-value {
      background-color: ${({ theme }) =>
        theme.fn.themeColor('Main/Primary/800')};
      transition: width 0.3s ease-in-out;
    }

    &::-moz-progress-bar {
      background-color: ${({ theme }) =>
        theme.fn.themeColor('Main/Primary/800')};
      transition: width 0.3s ease-in-out;
    }

    @media (prefers-reduced-motion: reduce) {
      &::-webkit-progress-value,
      &::-moz-progress-bar {
        transition: none;
      }
    }
  `
);
